"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = _default;
var _globalSpacing = require("./../../globalSpacing");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _default(context, classes) {
  var _ref;
  var padding = context.padding,
    spacingOptions = context.spacingOptions,
    responsive = context.responsive;
  return (0, _isEmpty.default)(spacingOptions) ? (_ref = {}, _ref[classes.standard] = padding === _globalSpacing.spacingVariant.STANDARD, _ref[classes.none] = padding === _globalSpacing.spacingVariant.NONE, _ref[classes.responsive] = responsive && padding !== _globalSpacing.spacingVariant.NONE, _ref) : (0, _globalSpacing.getSpacingStyles)({}, _globalSpacing.spacingType.COMPONENT_RESET);
}